import dayjs from "dayjs";
import { RetireFlowReason, RetireReason } from "../../../assets/data/Constants";
import { IJob_32Props } from "../../../type/contextType/businessContext/IJob_32";

/**
 * 業務タイプ判定
 * @param retireReasonCd 入出力項目.退職理由
 * @param retireProcedureReason 入出力項目.退職手続きの理由
 * @param context 持回情報（JOB-32）
 * @returns
 */
export const businessTypeJudgement = (
  retireReasonCd: any,
  retireProcedureReason: any,
  context?: IJob_32Props,
  retireDate?: string
): "JOB-31" | "JOB-33" | "JOB-32" => {
  /**
   * ①入出力項目.退職理由コード=1以外の場合
   * ②持回情報.退職日変更可否フラグ=0の場合
   */
  if (
    retireReasonCd !== RetireReason["普通退職"] ||
    context?.retireDateModifiableFlg === "0"
  ) {
    return "JOB-31";
  }

  /**
   * ③入出力項目.退職理由コード=1&入出力項目.退職手続きの理由=法人都合
   * &職員の在籍期間<１年の場合
   * ④持回情報.継続異動該当条件１フラグ=1&継続異動該当条件２フラグ=1の場合
   */
  if (
    retireReasonCd === RetireReason["普通退職"] &&
    retireProcedureReason === RetireFlowReason["法人（業務上の）都合"] &&
    isLessThanOneYear(context?.joinDate, retireDate)
  ) {
    return "JOB-33";
  }

  /**
   * ⑤入出力項目.退職手続きの理由=法人都合の場合、JOB-32
   */
  return "JOB-32";
};

// 職員の在籍期間：１年未満であることを判定
export const isLessThanOneYear = (start: any, end: any) => {
  const startDate = dayjs(start).subtract(1, "day");
  const endDate = dayjs(end).subtract(1, "year");

  return startDate > endDate;
};
